import {
  BankOutlined,
  MenuOutlined,
  PrinterFilled,
  UserOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';

const iconStyle = { fontSize: '28px' };

export const dashboardBoxes = [
  {
    key: 'branch',
    title: 'Branch List',
    description: 'View and manage all your store branches.',
    type: 'navigation',
    route: '/branch/list/',
    icon: <BankOutlined style={iconStyle} />,
    accent: '#2f54eb',
    tint: '#f0f5ff',
  },
  {
    key: 'users',
    title: 'Users',
    description: 'Add, edit and organize system users.',
    type: 'navigation',
    route: '/user/list/',
    icon: <UserOutlined style={iconStyle} />,
    accent: '#12a36c',
    tint: '#f6ffed',
  },
  {
    key: 'role',
    title: 'Roles',
    description: 'Define roles and access levels.',
    type: 'navigation',
    route: '/role/list/',
    icon: <UserSwitchOutlined style={iconStyle} />,
    accent: '#13a8a8',
    tint: '#e6fffb',
  },
  {
    key: 'role_menu',
    title: 'Role Menu',
    description: 'Map menus and permissions to roles.',
    type: 'navigation',
    route: '/role/menu/mapping/list/',
    icon: <MenuOutlined style={iconStyle} />,
    accent: '#fa8c16',
    tint: '#fff7e6',
  },
  {
    key: 'printer',
    title: 'Printer Settings',
    description: 'Configure receipt and label printers.',
    type: 'navigation',
    route: '/printer/list/',
    icon: <PrinterFilled style={iconStyle} />,
    accent: '#722ed1',
    tint: '#f9f0ff',
  },
];
